// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-hero{position:relative;z-index:-1;height:65vh;overflow:hidden;background-color:#000}.layout-hero img{position:absolute;top:50%;left:50%;width:auto!important;min-width:100%;max-width:none;height:auto!important;min-height:100%;max-height:none;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
